import { IMaintenanceData } from 'js/components/system/App/store/types';

export const isMaintenanceModeEnabled = (config: IMaintenanceData, isIntegrationScriptLoaded: boolean | null): any => {
    const { isMaintenanceEnabled, isAutoDetectEnabled, isSchedulerEnabled, startDate, endDate } = config;
    const getMaintenanceEnabledByCMS = (): boolean => {
        if (!isMaintenanceEnabled) {
            return false;
        }

        if (!isAutoDetectEnabled && !isSchedulerEnabled) {
            return true;
        }

        if (isAutoDetectEnabled && !isSchedulerEnabled) {
            return false;
        }

        const currentDate = Date.now();
        const parsedStartDate = Date.parse(startDate);
        const parsedEndDate = Date.parse(endDate);

        return parsedStartDate <= currentDate && currentDate < parsedEndDate;
    };

    const isMaintenanceEnabledByCMS = getMaintenanceEnabledByCMS();
    const isMaintenanceEnabledByScript = isMaintenanceEnabled && isAutoDetectEnabled && isIntegrationScriptLoaded === false;

    return isMaintenanceEnabledByCMS || isMaintenanceEnabledByScript;
};
